import React from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import { Checkbox } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import { List, ListItem } from '@dbk/ui-list';
import PropTypes from 'prop-types';
import { DOC_UPLOAD } from '../../../../../constants'
import Popover from '@dbk/ui-popover';
import { TrashCircle, Info2 } from '@dbk/ui-icons';


const contractList = (props) => {
  const {
    i18n:{ messages }, contractListData, disabled, onItemClick } = props;
    
  return (
          <div className="columns small-12
                           medium-12 large-12
                           document-upload">
                           <div className="columns large-12 contractList-table-border">
                  <div className="cloumns small-12 medium-12 large-12 borderSearchTable">
                    <div className="cloumns small-12 medium-12 large-12 borderBottomHeading">
                      <div className="columns large-3 medium-3 small-12 tableHeading">
                        <span>{messages['app.documentUpload.contractNo']}</span>
                      </div>
                      <div className="columns large-2 medium-3 small-12 tableHeading" >
                        <span>{messages['app.documentUpload.userName']}</span>
                      </div>
                      <div className="columns large-3 medium-2 small-12 tableHeading">
                        <span>{messages['app.documentUpload.userRole']}</span>
                      </div>
                      <div className="columns large-2 medium-2 small-12 tableHeading">
                        <span>{messages['app.documentUpload.domicile']}</span>
                      </div>
                      <div className="columns large-2 medium-2 small-12 tableHeading">
                        <span>{messages['app.documentUpload.status']}</span>
                      </div>
                    </div>
                     
                    <List
                      testID="bpSearchList"
                      
                      className="contractList-table-innerBorder large-12 medium-12 small-12" >
                      {contractListData && contractListData.map((option, index) =>
                       <ListItem
                              // style={{backgroundColor: '#000e28'}}
                              disabled={option.status === DOC_UPLOAD.NON_DWO_USER || option.authority === null}
                              >
                                <div className="row-fluid large-12 small-12 medium-12">
                                  <div className="columns large-3 medium-3 small-12">
                                { !disabled && <Checkbox checked={option.isChecked}
                                    disabled={option.status === DOC_UPLOAD.NON_DWO_USER || option.authority === null}
                                    textID={`chkBx_uploadDoc_${index}_test`}
                                    accessibilityLabel={`chkBx_uploadDoc_${index}_test`}
                                    name="ebankContractList"
                                    onChange={(e) => onItemClick(e, option)} /> }
                                    <span className="doc-upload-tabel-contract-no contract-list-item">{option.contract || DOC_UPLOAD.NA }</span>
                                  </div>
                                  <div className="columns large-2 medium-3 small-12 searchRecord contract-list-item">
                                    {option.userName || DOC_UPLOAD.NA}
                                  </div>
                                  <div className="columns large-3 medium-2 small-12 searchRecord contract-list-item">
                                    {option.authority || DOC_UPLOAD.NO_DWO_ACCESS}
                                  </div>
                                  <div className="columns large-2 medium-2 small-12 searchRecord contract-list-item">
                                    {option.domicile || DOC_UPLOAD.NA}
                                  </div>
                                  <div className="columns large-2 medium-2 small-12 searchRecord contract-list-item" style={{    display: 'flex'}}>
                                    {option.status || DOC_UPLOAD.NA}
                                    <span>
                                      <Popover
                                          mode="popup"
                                          orientation="top"
                                          position={10}
                                          showOnHover
                                          testID={`popover_manage_device_model_test`}
                                          accessibilityLabel={`popover_manage_device_model_test`}
                                          popOverClassName="manage-details-action-content"
                                          content={
                                            <div testID={`popover_text_manage_device_model_test`} accessibilityLabel={`popover_text_manage_device_model_test`}>
                                              { option.status === DOC_UPLOAD.NON_DWO_USER && <Text secondary>{messages['app.docUpload.notDWOUser']}</Text> }
                                              { option.status === DOC_UPLOAD.STATUS.INACTIVE && <Text secondary>{messages['app.docUpload.contract.status.inactive']}</Text> }
                                              { option.status === DOC_UPLOAD.STATUS.ACTIVE && <Text secondary>{messages['app.docUpload.contract.status.active']}</Text> }
                                            </div>
                                          }
                                          >
                                          <Info2 color="#999999" />
                                        </Popover>
                                    </span>

                                  </div>
                                </div>
                          </ListItem>
                      )}
                    </List>
                  </div>
                </div>

            </div>)
};

contractList.propTypes = {
  onItemClick: PropTypes.func,
  contractListData: PropTypes.object,
  disabled: PropTypes.boolean
};

contractList.defaultProps = {
  onItemClick: () => {},
 
};

export default createContainer({
    $queries: {
      i18n: {
        messages: true,
      },
    }
  })(contractList)
  